import React, { useEffect } from "react";
import Header from "../components/Header";
import "../styles/global.css";

const Terms = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = "Terms of Use | Relationship Wellness";
  }, []);

  return (
    <div className="terms-container bg-gray-50 min-h-screen">
      <Header />
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-4xl py-12">
        <header className="mb-10">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">
            Terms of Use
          </h1>
          <p className="text-gray-600">
            <strong>Last updated:</strong> January 1, {new Date().getFullYear()}
          </p>
        </header>

        <section className="bg-white shadow-sm rounded-lg p-8">
          <p className="text-gray-700 mb-6 leading-relaxed">
            Please read these Terms of Use (“Terms”) carefully before using the
            Relationship Wellness website (the “Service”) operated by
            Relationship Wellness (“us”, “we”, or “our”).
          </p>

          <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">
            Acceptance of Terms
          </h2>
          <p className="text-gray-700 mb-6 leading-relaxed">
            By accessing or using our Service, you agree to be bound by these
            Terms. If you disagree with any part of the Terms, you may not
            access the Service.
          </p>

          <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">
            Content
          </h2>
          <p className="text-gray-700 mb-6 leading-relaxed">
            The resources, assessments, articles, and blog posts provided are
            for informational and educational purposes only. While our materials
            are informed by evidence-based psychological research,{" "}
            <span className="font-medium">
              they are not a substitute for professional medical or mental
              health advice
            </span>
            . Always consult with a qualified health provider with questions
            regarding any mental health or relationship issue.
          </p>

          <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">
            User Accounts
          </h2>
          <p className="text-gray-700 mb-6 leading-relaxed">
            Some features may require you to create an account. You must provide
            accurate and complete information. You are responsible for
            maintaining the confidentiality of your account and password and for
            restricting access to your computer or device.
          </p>

          <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">
            Intellectual Property
          </h2>
          <p className="text-gray-700 mb-6 leading-relaxed">
            The Service and its original content, features, and functionality
            are and will remain the exclusive property of Relationship Wellness
            and its licensors. Content may not be republished, redistributed, or
            used for commercial purposes without explicit written permission.
          </p>

          <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">
            Links to Other Websites
          </h2>
          <p className="text-gray-700 mb-6 leading-relaxed">
            Our Service may contain links to third-party websites or services
            that are not owned or controlled by Relationship Wellness. We have
            no control over, and assume no responsibility for, the content,
            privacy policies, or practices of any third-party websites or
            services.
          </p>

          <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">
            Disclaimer
          </h2>
          <p className="text-gray-700 mb-6 leading-relaxed">
            The Service is provided on an “AS IS” and “AS AVAILABLE” basis.
            Relationship Wellness makes no warranties, expressed or implied. We
            strive for accuracy and reliability but do not warrant that the
            Service will be error-free or uninterrupted.
          </p>

          <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">
            Limitation of Liability
          </h2>
          <p className="text-gray-700 mb-6 leading-relaxed">
            In no event shall Relationship Wellness, nor its directors,
            employees, partners, agents, or affiliates, be liable for any
            indirect, incidental, special, consequential, or punitive damages,
            including loss of profits, data, goodwill, or other intangible
            losses, resulting from (i) your use or inability to use the Service;
            (ii) any unauthorized access to or use of our servers and/or any
            personal information stored therein; or (iii) otherwise in
            connection with these Terms.
          </p>

          <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">
            Advertisements and Sponsorships
          </h2>
          <p className="text-gray-700 mb-6 leading-relaxed">
            Our website may include sponsored content and advertisements.
            Sponsored or paid ads will always be clearly identified. We may
            receive compensation if you click these links or make purchases via
            third-party vendors. See our{" "}
            <a href="/privacy-policy" className="text-blue-600 hover:underline">
              Privacy Policy
            </a>{" "}
            for details on third-party data usage.
          </p>

          <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">
            Governing Law
          </h2>
          <p className="text-gray-700 mb-6 leading-relaxed">
            These Terms shall be governed and construed in accordance with the
            laws of California, United States, without regard to its conflict of
            law provisions.
          </p>

          <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">
            Changes
          </h2>
          <p className="text-gray-700 mb-6 leading-relaxed">
            We reserve the right, at our sole discretion, to modify or replace
            these Terms at any time. If a revision is material, we will try to
            provide at least 30 days’ notice prior to any new terms taking
            effect. Your continued use of the Service will mean acceptance of
            the new Terms.
          </p>

          <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">
            Contact Us
          </h2>
          <p className="text-gray-700 leading-relaxed">
            If you have any questions about these Terms, please contact us at{" "}
            <a
              href="mailto:support@nivexa.net"
              className="text-blue-600 hover:underline">
              support@nivexa.net
            </a>
            .
          </p>
        </section>
      </div>
    </div>
  );
};

export default Terms;
